module.exports = __webpack_public_path__ + "img/canyu-title.8af359e4.png";